import React from "react";

const ArrowIcon = ({ width = 14, height = 10, fill, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6659 4.33294L13.666 5.66621L2.88475 5.66621L5.51788 8.29938L4.57508 9.24219L0.332417 4.99954L4.57508 0.756873L5.51788 1.69974L2.88468 4.33287L13.6659 4.33294Z"
      fill={fill || "currentColor"}
    />
  </svg>
);

export default ArrowIcon;
